module.exports = __webpack_public_path__ + "img/logo.fd07c33f.png";